var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dp-container',[_c('div',{staticClass:"pt-5"},[_c('DpPetTrackingDeviceAddToOrder',{attrs:{"api-token":_vm.userToken,"api-url":_vm.apiUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }